// Single source of truth for the client-side session.
// The API returns numbers and flags inconsistently (0 vs "0", 1 vs "1"),
// so every login/subscription check in the app should go through here.

const USER_KEY = 'userDetails';
const TOKEN_KEY = 'sessiontoken';

const isBlank = (value) =>
  value === undefined || value === null || value === '' || value === 'undefined' || value === 'null';

const isTruthyFlag = (value) => value === true || value === 1 || value === '1' || value === 'true';

export const getStoredToken = () => {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    return isBlank(token) ? '' : token;
  } catch (e) {
    return '';
  }
};

export const loadStoredUser = () => {
  try {
    const raw = localStorage.getItem(USER_KEY);
    if (isBlank(raw)) return null;
    const user = JSON.parse(raw);
    return user && typeof user === 'object' ? user : null;
  } catch (e) {
    return null;
  }
};

export const isLoggedIn = (user) => Boolean(user) && !isBlank(user.sessionToken || getStoredToken());

export const hasSubscription = (user) => {
  if (!isLoggedIn(user)) return false;
  if (isTruthyFlag(user.isPremium)) return true;
  const subscription = Number(user.subscription);
  return Number.isFinite(subscription) && subscription > 0;
};

// Stores a user object returned by the API. Keeps the existing session token
// when the response does not carry one, so a partial payload never logs the user out.
export const persistUser = (dispatch, user) => {
  if (!user || typeof user !== 'object') return;
  const token = isBlank(user.sessionToken) ? getStoredToken() : user.sessionToken;
  const next = token ? { ...user, sessionToken: token } : user;
  dispatch({ type: 'userDetails', value: next });
  try {
    localStorage.setItem(USER_KEY, JSON.stringify(next));
    if (token) localStorage.setItem(TOKEN_KEY, token);
  } catch (e) {
    /* storage unavailable */
  }
};

// Applies a partial update to the stored user (profile pic, name, flags).
export const updateStoredUser = (dispatch, patch) => {
  const current = loadStoredUser();
  if (!current) return;
  persistUser(dispatch, { ...current, ...patch });
};

export const clearSession = (dispatch) => {
  dispatch({ type: 'userDetails', value: null });
  try {
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(TOKEN_KEY);
  } catch (e) {
    /* storage unavailable */
  }
};
